import {
  merchantKnowledgeArticleSchema,
  merchantKnowledgeDraftSchema,
} from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Content only. Availability is a separate call so a save cannot publish. */
export const updateKnowledgeArticle = {
  name: "updateKnowledgeArticle" as const,
  input: z.object({
    id: merchantKnowledgeIdFormat.schema,
    draft: merchantKnowledgeDraftSchema,
  }),
  output: merchantKnowledgeArticleSchema,
};
